export default {
    reports:"Reports",
    inventory: "Inventory",
    visit: "Visit",
    service: "Service",
    doctor: "Doctor",
    staff: "Staff"
}